import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { backofficeUnauthorizedResponseSchema } from "~infrastructure/api/backoffice/contract/global/responses/global-backoffice-responses.ts";

const c = initContract();

export const othersBackofficeContract = c.router(
  {
    hello: {
      method: "GET",
      path: "/api/hello",
      responses: {
        200: z.void(),
        401: backofficeUnauthorizedResponseSchema,
      },
    },
  },
  {
    strictStatusCodes: true,
  },
);
